import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface SponsorMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allSponsorMaster: [] | null | any;
}
const initialState: SponsorMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allSponsorMaster: null,
};
export const sponsorMasterSlice = createSlice({
  name: 'SponsorMaster',
  initialState,
  reducers: {
    setAllSponsorMaster: (state, action) => {
      state.allSponsorMaster = action.payload.data;
    },
    setSponsorMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllSponsorMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllSponsorMaster, setSponsorMaster, setAllSponsorMasterBySearch,reset } = sponsorMasterSlice.actions;
export const allSponsorMasterDetails = (state: RootState) => state.sponsorMaster.allSponsorMaster;
export const getAllSponsorMasterDetails = (state: RootState) => state.sponsorMaster.data;
export const getSponsorMasterTotalRecords=(state:RootState)=>state.sponsorMaster.totalRecords;
export const getAllSponsorMasterBySearch = (state: RootState) => state.sponsorMaster.data;
export default sponsorMasterSlice.reducer;